import { apiClient } from '@/lib/api-client';
import { AssumeRoleRequest, AssumeRoleResponse } from '@/types';

/**
 * Assumes a role in an organization.
 * @param data - The assume role request data
 * @returns {Promise<AssumeRoleResponse>} A promise that resolves to the assume role response.
 */
export async function assumeRole(data: AssumeRoleRequest): Promise<AssumeRoleResponse> {
  const res = await apiClient.post<AssumeRoleResponse>('/auth/assume-role', data);
  if (!res) {
    throw new Error('Failed to assume role: No response received');
  }
  return res;
}
